import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
export class ItemGridTaxSumItem {
    public TaxName: string = '';
    public TotalWithoutTax_WithDiscount: number = 0;
    public TotalTax_WithDiscounts: number = 0;
    public Total_WithDiscounts: number = 0;
    public Total_WithoutDiscounts: number = 0;

    constructor (TaxName: string, TotalWithoutTax_WithDiscount: number, TotalTax_WithDiscounts: number, Total_WithDiscounts: number, Total_WithoutDiscounts: number) {
        this.TaxName = TaxName;
        this.TotalWithoutTax_WithDiscount = TotalWithoutTax_WithDiscount;
        this.TotalTax_WithDiscounts = TotalTax_WithDiscounts,
        this.Total_WithDiscounts = Total_WithDiscounts;
        this.Total_WithoutDiscounts = Total_WithoutDiscounts;
    }
}
